import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nPipe } from './pipes/i18n.pipe';
import { HttpModule } from '../http/http.module';


@NgModule({
  declarations: [
    I18nPipe
  ],
  exports: [
    I18nPipe
  ],
  imports: [
    CommonModule,
    HttpModule
  ]
})
export class I18nModule {
}
